export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 24 L16 7 L26 24 Z" />
      <path d="M10 19 L22 19" />
    </svg>
  );
}
